import { Flashbar } from 'AWS-UI-Components-React';
import React from 'react';
import { ERROR_MESSAGE } from '../../../constants/views';
import { extractErrorMessage } from '../../../utilities';
import logger from '../../../utils/logging';
import { getJSClient } from '../../js_client';
import { ChannelMappingTable } from './channel_mapping_table';

export class ChannelMapperContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      channelMappings: [],
      errorScreenMessage: null,
    };
  }

  componentWillMount = () => {
    this.client = getJSClient();
    this.initialClientTasks();
  };

  initialClientTasks = () => {
    this.getChannelMappings();
  };

  getChannelMappings = () => {
    this.client.getChannelMappings((result) => {
      this.onChannelMappingsPullSuccess(result)
    }, (error) => this.onChannelMappingsPullFailure(error));
  };

  onChannelMappingsPullFailure = (error) => {
    logger.error(extractErrorMessage(error), error);
    this.setState({ errorScreenMessage: extractErrorMessage(error) });
  };

  onChannelMappingsPullSuccess = (result) => {
    if (result.data) {
      this.setState({channelMappings: result.data.channelMappings});
    } else {
      this.setState({channelMappings: result.channelMappings});
    }
  };

  render() {
    const { channelMappings, errorScreenMessage } = this.state;

    return (
      <div>
      <div>
        <Flashbar
          items={
            errorScreenMessage
            ? [
                {
                  type: 'error',
                  dismissible: true,
                  content: `${ERROR_MESSAGE}${errorScreenMessage}`,
                  dismiss: () => this.setState({ errorScreenMessage: null }),
                },
              ]
            : []
          }
        />
      </div>
      <div className="awsui-util-container">
        <ChannelMappingTable
          channelMappings={channelMappings}
        />
      </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/channel_mapping/channel_mapping_container.jsx